import src from "IMAGE";
export default { src, width: 364, height: 48, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ADwWe25AF4J0OBVyZiIVP20RFRhxExYaeRIWGXUUGBt/hhgHeMTnuc0AAAAASUVORK5CYII="};
